import * as sequencedInterviewActions from 'interview/actions/sequenced-interview'

export default function reducer(state, action = {}) {
  const newState = { ...state }

  switch (action.type) {
    case sequencedInterviewActions.NETWORK_TEST_START: {
      newState.networkTest = { testing: true }
      break
    }

    case sequencedInterviewActions.QUALITY_TEST_START: {
      newState.qualityTest = { testing: true }
      break
    }

    case sequencedInterviewActions.NETWORK_TEST_DATA_UPDATE: {
      const results = action.payload
      if (
        results &&
        !results.success &&
        results.failedTests.length > 0 &&
        results.failedTests[0].error
      ) {
        const { error } = results.failedTests[0]
        if (error.name === 'FailedToCreateLocalPublisher') {
          newState.errorType = 'initPublisherError'
        } else if (error.name === 'ConnectToSessionNetworkError') {
          newState.errorType = 'networkError'
        } else {
          newState.errorType = 'generalError'
        }
      } else {
        newState.errorType = ''
      }
      newState.networkTest = { results: action.payload, testing: false }
      break
    }

    case sequencedInterviewActions.QUALITY_TEST_DATA_UPDATE: {
      const results = action.payload
      const audioSupported =
        results &&
        results.audio.supported &&
        results.audio.mos > 2.0 &&
        results.audio.bitrate > 15000
      const videoSupported =
        results && results.video.supported && results.video.mos > 2.0
      const testSuccess = audioSupported && videoSupported

      const newResults = results && {
        audio: {
          ...results.audio,
          supported: audioSupported,
        },
        video: {
          ...results.video,
          supported: videoSupported,
        },
      }

      newState.qualityTest = {
        results: newResults,
        testing: false,
        testSuccess,
      }
      break
    }

    case sequencedInterviewActions.ERROR_UPDATE: {
      newState.errorType = action.payload
      break
    }

    case sequencedInterviewActions.INTERVIEW_STATE_UPDATE: {
      newState.interviewState = { ...state.interviewState, ...action.payload }
      break
    }

    default:
  }

  return newState
}
